// Global css files
import '~/common/styles/reset.css';
import '~/common/styles/default.css';
import '~/common/styles/legacy-blocker.css';

// Import Dependencies
import React, { Component, Fragment } from 'react';
import { ghTrialFeatureDisabled, ghTrialSelected } from '~/common/globals.js';
import { inject, observer } from 'mobx-react';

// import BrowserRouter
import { Router } from 'react-router-dom';

// Import route Components
import Routes from '~/Routes.js';
import TrustArc from '~/common/components/TrustArc';
import UpgradeModal from '~/common/components/UpgradeModal';
import { history } from '~/common/stores/stores';

import QualifiedChat from '~/common/components/QualifiedChat';
import CantLockNumberToSessionModalContent from '~/common/components/CantLockNumberToSessionModalContent';
import CompletingSignupBlocker from '~/common/components/CompletingSignupBlocker';
import CreditCardTypeModal from '~/common/components/CreditCardTypeModal';
import { FLOW_STEP_PLANS } from '~/common/utils/consts.js';
// import modal, modal content used in this flow
import FatalErrorModal from '~/common/components/FatalErrorModal';
import InternationalBlocker from '~/views/InternationalBlocker';
import LockingNumberBlocker from '~/common/components/LockingNumberBlocker';
import LoginLmiModal from '~/common/components/LoginLmiModal';
import LoginModal from '~/common/components/LoginModal';
import MaxWidthLayout from '~/common/components/MaxWidth';
import Modal from '~/common/components/Modal';
import ModalBlocker from '~/common/components/ModalBlocker';
import TrueSoloTrialConversionModal from './common/components/TrueSoloTrialConversionModal';
import VideoModal from './common/components/VideoModal';

// components to render in modal
const modalChildComponents = {
    fatalErrorModal: <FatalErrorModal />,
    cantLockNumberToSessionModalContent: <CantLockNumberToSessionModalContent />,
    upgradeModal: <UpgradeModal />,
    loginModal: <LoginModal />,
    loginLmiModal: <LoginLmiModal />,
    creditCardType: <CreditCardTypeModal />,
    modalBlockerModal: <ModalBlocker />,
    trueSoloTrialConversionModal: <TrueSoloTrialConversionModal />,
    videoModal: <VideoModal />
};

// export an app Component, that contains the Router, plus Modal funtionality
@inject('modalStore', 'lockNumberStore', 'progressStore', 'trialSignupStore', 'userLocationStore')
@observer
class App extends Component {
    componentDidMount() {
        const { lockNumberStore, trialSignupStore, progressStore, modalStore } = this.props;

        if (ghTrialSelected() === 'true') { // checks for Preselected Trial
            trialSignupStore.setIsTrialFlow(true);
            progressStore.setFirstView(FLOW_STEP_PLANS);
        }

        if (ghTrialFeatureDisabled() === 'true') { // checks for Disabled Trial
            trialSignupStore.setIsTrialFeatureDisabled(true);
        }

        if (ENV === 'production') {
            window.onbeforeunload = () => {
                if (lockNumberStore.selectedNumberE164 &&
                    lockNumberStore.numberIsLocked &&
                    (!modalStore.isModalOpen || (modalStore.isModalOpen && modalStore.childComponentString !== 'fatalErrorModal'))
                ) {
                    return 'Leaving this page will cause you to lose all your progress.';
                }
                return undefined;
            };
        }
    }

    renderModalChildComponent() {
        // if there is a subroute that matches
        if (modalChildComponents[this.props.modalStore.childComponentString]) {
            // return subroute component
            return modalChildComponents[this.props.modalStore.childComponentString];
        }
        // otherwise return nothing
        return null;
    }

    render() {
        const { isSignupAllowed } = this.props.userLocationStore;
        return (
            // insert router
            <Fragment>
                <Router history={history}>
                    <Fragment>
                        <MaxWidthLayout>
                            {isSignupAllowed ?
                                <Fragment>
                                    <Routes />
                                    <LockingNumberBlocker />
                                    <CompletingSignupBlocker />
                                    <ModalBlocker />
                                    <Modal>{this.renderModalChildComponent()}</Modal>
                                </Fragment>
                                :
                                <InternationalBlocker />
                            }
                        </MaxWidthLayout>
                    </Fragment>
                </Router>
                <QualifiedChat />
                <TrustArc />
            </Fragment>
        );
    }
}

// this is imported in the entry.js file
export default App;
